<template>
  <InlineSvg class="fiksucity-logo" :class="{ dark }" :src="logo" role="img" :alt="alt" />
</template>

<script>
import InlineSvg from "vue-inline-svg"

export default {
  components: { InlineSvg },

  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    logo() {
      return "/img/fiksucitylogo.svg"
    },
    alt() {
      return "Fiksu City"
    },
  },
}
</script>

<style scoped>
.fiksucity-logo.dark >>> path.st0 {
  fill: #fafafa !important;
}
.fiksucity-logo.dark >>> path.st1 {
  fill: #50c5ff !important;
}
.fiksucity-logo.dark >>> path.st2 {
  fill: #929292 !important;
}
</style>
